import React, { useState, useEffect } from "react";
import {
  ArrowLeft,
  PlusCircle,
  Eye,
  Edit,
  Edit2,
  Trash2,
  Users,
} from "react-feather";
import { Link } from "react-router-dom";
import Table from "core/pagination/datatable";
import TableTop from "Components/UI/TableTop";
import { useTableSearch } from "core/Operations/useTableSearch";
import { useForm, FormProvider } from "react-hook-form";
import { format } from "date-fns";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import { all_routes } from "Router/all_routes";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import Error404 from "MainPages/ErrorPages/error404";
import { yupResolver } from "@hookform/resolvers/yup";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Popconfirm, Switch } from "antd";

import { message } from "antd";
import {
  useDeleteUserMasterMutation,
  useGetAllUserMasterQuery,
  useInsertUserMasterMutation,
  useUpdateUserMasterMutation,
} from "AppQuries/user/user-master";
import ReportTools from "Components/UI/ReportTools";
import LimitationAlert from "Components/UI/LimiitationAlert";
import Can from "core/Operations/Can";
import { accessCodes } from "core/json/accessCode";
const UserMaster = () => {
  const userData = useSelector(loggedInUser);
  const [showActiveOnly, setShowActiveOnly] = useState(true);
  const [isMount, setIsMount] = useState(false);
  const {
    data,
    isLoading,
    isError,
    error,
    refetch: GetItems,
  } = useGetAllUserMasterQuery(
    {
      companyCode: userData?.companyCode,
      locationCode: userData?.selectedLocationCode,
      //   isTrue: showActiveOnly,
    },
    {
      enabled: userData?.companyCode,
    }
  );
  const methods = useForm({
    // resolver: yupResolver(bankValidationSchema),
  });
  const [isFilterVisible, setIsFilterVisible] = useState(false);

  const { mutate: addItem, isPending: isAdding } =
    useInsertUserMasterMutation();
  const { mutate: updateItem, isPending: isUpdating } =
    useUpdateUserMasterMutation();

  const { mutate: deleteItem, isPending: isDeleting } =
    useDeleteUserMasterMutation();
  const [selectedItem, setSelectedItem] = useState(null);
  const [showErrorToast, setShowErrorToast] = useState(false);
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const ItemData = Array.isArray(data)
    ? data?.map((d, _id) => ({
        id: _id + 1,
        ...d,
      }))
    : [];

  const handleAddClick = () => {
    setSelectedItem(null);
    methods.reset({
      companyCode: userData.companyCode,
      code: 0,
      description: "",
      branchCode: "",
      isActive: true,
      createUser: userData.userName,
      createDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
      modifyUser: userData.userName,
      modifyDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
    });
    setShow(true);
  };

  const handleEditClick = (item) => {
    setSelectedItem(item);
    methods.reset({
      companyCode: item.companyCode,
      code: item.code,
      description: item.description,
      branchCode: item.branchCode,
      isActive: item.isActive,
      createUser: item.createUser,
      createDate: item.createDate,
      modifyUser: userData.userName,
      modifyDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
    });
    setShow(true);
  };

  const deleteItemHandler = (id) => {
    const payload = {
      companyCode: userData?.companyCode,
      code: id,
    };
    deleteItem(payload, {
      onSuccess: (data) => {
        if (data) {
          message.success("User Master Deleted Successfully.");
          setSelectedItem(null);
          setShow(false);
          GetItems();
        } else {
          message.success(data?.[0]?.errorMessage || "Something went wrong.");
        }
      },
      onError: (error) => {
        message.success(error.message || "Something went wrong.");
      },
    });
  };

  const onSubmit = async (payload) => {
    if (selectedItem) {
      updateItem(payload, {
        onSuccess: (data) => {
          if (data) {
            message.success("User Master Updated Successfully.");
            setSelectedItem(null);
            setShow(false);
            GetItems();
          } else {
            message.success(data?.[0]?.errorMessage || "Something went wrong.");
          }
        },
        onError: (error) => {
          message.success(error.message || "Something went wrong.");
        },
      });
    } else {
      addItem(payload, {
        onSuccess: (data) => {
          console.log(data);
          if (data) {
            message.success("Bank Added Successfully");
            setShow(false);
            GetItems();
          } else {
            message.danger(data?.[0]?.errorMessage || "Something went wrong.");
          }
        },
        onError: (error) => {
          message.danger(error.message || "Something went wrong.");
        },
      });
    }
  };

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  const columns = [
    {
      title: "S.No",
      dataIndex: "id",
      sorter: (a, b) => a.id.length - b.id.length,
      render: (text, record) => <>{text}</>,
    },

    // {
    //   title: "User ID",
    //   dataIndex: "userID",
    //   sorter: (a, b) => a.userID.length - b.userID.length,
    // },
    {
      title: "User Name",
      dataIndex: "userName",
      sorter: (a, b) => a.userName.length - b.userName.length,
    },
    {
      title: "User Group Code",
      dataIndex: "userGroupCode",
      sorter: (a, b) => a.userGroupCode.length - b.userGroupCode.length,
    },
    {
      title: "Email Id",
      dataIndex: "emailId",
      sorter: (a, b) => a.emailId.length - b.emailId.length,
    },
    {
      title: "Created User",
      dataIndex: "createUser",
      sorter: (a, b) => a.createUser.length - b.createUser.length,
    },
    {
      title: "Lock Status",
      dataIndex: "isLock",
      render: (text, record) => (
        <>
          {text === true && (
            <div className="badges badge-linedanger">Locked</div>
          )}
          {text === false && (
            <div className="badges badge-linesuccess"> Active</div>
          )}
        </>
      ),
    },
    {
      title: "Status",
      dataIndex: "isActive",
      render: (text, record) => (
        <>
          {text === true && (
            <div className="badges badge-linesuccess">Active</div>
          )}
          {text === false && (
            <div className="badges badge-linedanger">In Active</div>
          )}
        </>
      ),
    },

    {
      title: "Action",
      dataIndex: "action",
      className: "action-table-data",
      render: (text, record) => (
        <div className="edit-delete-action">
          <div className="input-block add-lists"></div>
          <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="add-new-tooltip">Edit</Tooltip>}
            >
              <Link
                className="me-2 p-2"
                to={`${all_routes.user_master}${all_routes.view_user_master}/${record.userID}`}
              >
                <Eye className="feather-view" />
              </Link>
            </OverlayTrigger>
          <Can
            accessModule={accessCodes.users}
            accessCode={accessCodes.user_master}
            accessType="haveEdit"
          >
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="add-new-tooltip">Edit</Tooltip>}
            >
              <Link
                className="me-2 p-2"
                to={`${all_routes.user_master}${all_routes.edit_user_master}/${record.userID}`}
              >
                <Edit className="feather-edit" />
              </Link>
            </OverlayTrigger>
          </Can>
          <Can
            accessModule={accessCodes.users}
            accessCode={accessCodes.user_master}
            accessType="haveDelete"
          >
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="add-new-tooltip">Delete</Tooltip>}
            >
              <Link className="me-2 p-2" to="#">
                <Popconfirm
                  title="Are you sure to Delete?"
                  onConfirm={() => deleteItemHandler(record.userID)}
                >
                  <Trash2 className="feather-delete" />
                </Popconfirm>
              </Link>
            </OverlayTrigger>
          </Can>
        </div>
      ),
    },
  ];

  const searchColumns = columns.map((column) => column.dataIndex);
  const { setSearchValue, filteredData } = useTableSearch(
    ItemData,
    searchColumns
  );

  useEffect(() => {
    if (isMount) GetItems();

    setIsMount(true);
  }, [showActiveOnly]);

  if (isLoading || isAdding || isUpdating) {
    return <LoadingSpinner />;
  }

  if (isError) {
    return <Error404 error={error} />;
  }

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* <Breadcrumbs maintitle="Call History" subtitle="Manage your products" /> */}
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>User Master</h4>
                <h6>Manage users</h6>
              </div>
            </div>

            <div className="page-btn">
              <ReportTools
                columns={columns}
                data={filteredData}
                fileName={`User Master Details`}
                pdfTheme="plain"
                refresh={GetItems}
              />
            </div>
            <div className="page-btn" style={{ display: "flex" }}>
              <Can
                accessModule={accessCodes.users}
                accessCode={accessCodes.user_master}
                accessType="haveAdd"
              >
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip id="add-new-tooltip">Add User Master</Tooltip>
                  }
                >
                  <Link
                    to={`${all_routes.user_master}${all_routes.add_user_master}`}
                    className="btn btn-added"
                    onClick={handleAddClick}
                  >
                    <PlusCircle className="me-2" />
                    Add
                  </Link>
                </OverlayTrigger>
              </Can>
              &nbsp;
              {/* <OverlayTrigger
                placement="top"
                overlay={<Tooltip id="add-new-tooltip">Back</Tooltip>}
              >
                <Link
                  to={`${all_routes.master}`}
                  className="btn btn-added btn-secondary"
                >
                  <ArrowLeft className="me-2" />
                  Back
                </Link>
              </OverlayTrigger> */}
            </div>
          </div>

          <div className="card table-list-card border-0">
            <div className="card-body">
              <TableTop
                onSearch={setSearchValue}
                toggleFilterVisibility={toggleFilterVisibility}
                isFilterVisible={isFilterVisible}
                showToggle={false}
              />
              <div
                className={`card${isFilterVisible ? " visible" : ""}`}
                id="filter_inputs"
                // style={{ display: isFilterVisible ? "block" : "none" }}
              >
                <div className="card-body pb-0">
                  {/* <div className="form-row row">
                    <div className="row">
                      <div className="col-lg-3 col-sm-6 col-12 mb-3">
                        <div className="form-group">
                          <Switch
                                checked={showActiveOnly}
                                checkedChildren="Show Active"
                                unCheckedChildren="Show All"
                                onChange={(checked) => setShowActiveOnly(checked)}
                              />
                        </div>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
              <div className="total-employees d-flex mb-3 justify-content-space-between align-items-center">
                <div className="d-flex justify-content-start align-items-center mb-0">
                  <h6>
                    <Users className="me-2" />
                    Total Users &nbsp;&nbsp;
                  </h6>
                  <LimitationAlert
                    totalNumber={ItemData.length}
                    totalAllowed={userData?.companyDetails.noOfUsers}
                  />
                </div>
              </div>

              <div className="table-responsive">
                <Table
                  className="table  datanew"
                  columns={columns}
                  dataSource={filteredData}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <FormProvider {...methods}>
        <BankModal
          mode={selectedItem ? "E" : "I"}
          onSubmit={onSubmit}
          show={show}
          handleClose={handleClose}
        />
      </FormProvider> */}
    </>
  );
};

export default UserMaster;
